<template>
  <a-card :bordered="false">
    <!-- 树形管理 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item :label="$t('分类名称')">
              <j-search-select-tag v-model="queryParam.treeCategory" :placeholder="$t('请选择分类名称查询')" :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                dict="classificationTree" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                        {{ toggleSearchStatus ? '收起' : '展开' }}
                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                      </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd(1)" type="primary" icon="plus">{{ $t('新增') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{
          selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table ref="table" size="middle" rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="ipagination" :loading="loading"
        :expandedRowKeys="expandedRowKeys" @change="handleTableChange" @expand="handleExpand">
        <span slot="action" slot-scope="text, record">
          <a @click="handleAdd(3,record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record)">
            <a>{{ $t('删除') }}</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="handleAdd(2,record)">{{ $t('添加下级') }}</a>
        </span>

      </a-table>
    </div>

    <sysCategory-modal ref="modalForm" @ok="modalFormOk"></sysCategory-modal>
  </a-card>
</template>

<script>

import { getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SysCategoryModal from './components/SysCategoryModal'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil';
import { deleteAction } from '@/api/manage'

export default {
  name: "SysCategoryList",
  mixins: [JeecgListMixin],
  components: {
    SysCategoryModal
  },
  data() {
    return {
      Update: 2,
      description: this.$t('分类字典管理页面'),
      url: {
        list: "/jeecg-engineering/sample/treeData/queryAllTreeList",
        childList: "/jeecg-engineering/sys/category/childList",
        delete: "/jeecg-engineering/sample/treeData/delete",
        exportXlsUrl: "/sys/category/exportXls",
        importExcelUrl: "sys/category/importExcel",
      },
      expandedRowKeys: [],
      hasChildrenField: "hasChild",
      pidField: "pid",
      dictOptions: {
      },
      subExpandedKeys: [],
      disableMixinCreated: true
    }
  },
  created() {
    this.loadTree();
  },
  computed: {
    importExcelUrl() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    columns() {
      return [
        {
          title: this.$t('分类名称'),
          dataIndex: 'treeName'
        },
        {
          title: this.$t('分类'),
          dataIndex: 'treeCategory',
          customRender: (text) => {
            //字典值翻译通用方法
            // const color = text == '0' ? 'yellow' : text == '1' ? 'orange' : text == '2' ? 'green' : 'red';
            return filterDictTextByCache('classificationTree', text);
          },
        },
        {
          title: this.$t('排序'),
          dataIndex: 'sortNo'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        }
      ]
    },
    tableProps() {
      let _this = this
      return {
        // 列表项是否可选择
        rowSelection: {
          selectedRowKeys: _this.selectedRowKeys,
          onChange: (selectedRowKeys) => _this.selectedRowKeys = selectedRowKeys
        }
      }
    }
  },
  methods: {
    // 获取初始化数据
    loadTree() {
      console.log('掉了');
      let params = {};
      // this.areaTree = [];
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = this.getDataByResult(res.result)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // loadData(arg){
    //   if(arg==1){
    //     this.ipagination.current=1
    //   }
    //   this.loading = true
    //   // let params = this.getQueryParams()
    //   let params = { treeCategory: this.Update };
    //   return new Promise((resolve) => {
    //     getAction(this.url.list,params).then(res=>{
    //       if(res.success){
    //         let result = res.result
    //         if(Number(result.total)>0){
    //           this.ipagination.total = Number(result.total)
    //           // this.dataSource = this.getDataByResult(res.result.records)

    //           this.dataSource = this.getDataByResult(res.result)
    //           console.log(this.dataSource,111111111);
    //           //update--begin--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
    //           return this.loadDataByExpandedRows(this.dataSource)
    //           //update--end--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
    //         }else{
    //           this.ipagination.total=0
    //           this.dataSource=[]
    //         }
    //       }else{
    //         this.$message.warning(res.message)
    //       }
    //     }).finally(()=>{
    //       this.loading = false
    //     })
    //   })
    // },
    getDataByResult(result) {
      if (result && result.length > 0) {
        return result.map(item => {
          //判断是否标记了带有子节点
          if (item[this.hasChildrenField] == '1') {
            let loadChild = { id: item.id + '_loadChild', name: 'loading...', isLoading: true }
            item.children = [loadChild]
          }
          return item
        })
      }
    },
    handleExpand(expanded, record) {
      // 判断是否是展开状态
      if (expanded) {
        this.expandedRowKeys.push(record.id)
        if (record.children.length > 0 && record.children[0].isLoading === true) {
          let params = this.getQueryParams();//查询条件
          params[this.pidField] = record.id
          getAction(this.url.childList, params).then((res) => {
            if (res.success) {
              if (res.result && res.result.length > 0) {
                record.children = this.getDataByResult(res.result)
                this.dataSource = [...this.dataSource]
              } else {
                record.children = ''
                record.hasChildrenField = '0'
              }
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      } else {
        let keyIndex = this.expandedRowKeys.indexOf(record.id)
        if (keyIndex >= 0) {
          this.expandedRowKeys.splice(keyIndex, 1);
        }
      }
    },
    initDictConfig() {
    },
    modalFormOk() {
      this.loadData()
    },
    // modalFormOk(formData, arr) {
    //   console.log('formData----------',formData);
    //   if (!formData.id) {
    //     this.addOk(formData, arr)
    //   } else {
    //     this.editOk(formData, this.dataSource)
    //     this.dataSource = [...this.dataSource]
    //   }
    // },
    editOk(formData, arr) {
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == formData.id) {
            arr[i] = formData
            break
          } else {
            this.editOk(formData, arr[i].children)
          }
        }
      }
    },
    async addOk(formData, arr) {
      if (!formData[this.pidField]) {
        this.loadData()
      } else {
        this.expandedRowKeys = []
        console.log("22222", arr)
        for (let i of arr) {
          await this.expandTreeNode(i)
        }
      }
    },
    expandTreeNode(nodeId) {
      return new Promise((resolve, reject) => {
        this.getFormDataById(nodeId, this.dataSource)
        let row = this.parentFormData
        this.expandedRowKeys.push(nodeId)
        let params = this.getQueryParams();//查询条件
        params[this.pidField] = nodeId
        getAction(this.url.childList, params).then((res) => {
          console.log("11111", res)
          if (res.success) {
            if (res.result && res.result.length > 0) {
              row.children = this.getDataByResult(res.result)
              this.dataSource = [...this.dataSource]
              console.log(this.dataSource, 55555);
              resolve()
            } else {
              row.children = ''
              row.hasChildrenField = '0'
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    getFormDataById(id, arr) {
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == id) {
            this.parentFormData = arr[i]
          } else {
            this.getFormDataById(id, arr[i].children)
          }
        }
      }
    },
    // 新增
    handleAdd(num, record) {
      if (num == 1) {
        // 最顶层添加
        // 传值
        this.$refs.modalForm.add(num);
        this.$refs.modalForm.title = this.$t("新增");

      } else if (num == 2) {
        // this.subExpandedKeys = [];
        // this.getExpandKeysByPid(record.id, this.dataSource, this.dataSource)
        // this.$refs.modalForm.subExpandedKeys = this.subExpandedKeys;
        this.$refs.modalForm.title = this.$t("添加子分类");
        this.$refs.modalForm.add(num, record.treeCategory, record.key);
        this.$refs.modalForm.disableSubmit = false;


      } else {
        this.$refs.modalForm.add(3, record.treeCategory, record);
        console.log(record, '树形结构..............');
        this.$refs.modalForm.title = this.$t("编辑");
      }


      this.$refs.modalForm.disableSubmit = true;
    },
    // 删除
    handleDelete: function (record) {
      let that = this;
      deleteAction(that.url.delete, { id: record.id }).then((res) => {
        console.log("删除");
        if (res.success) {
          //update--begin--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
          that.loadTree();
          //update--end--autor:lvdandan-----date:20201204------for：JT-31 删除成功后默认展开已展开信息
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    // 添加子分类时获取所有父级id
    getExpandKeysByPid(pid, arr, all) {
      if (pid && arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == pid) {
            this.subExpandedKeys.push(arr[i].id)
            this.getExpandKeysByPid(arr[i]['pid'], all, all)
          } else {
            this.getExpandKeysByPid(pid, arr[i].children, all)
          }
        }
      }
    },
    // 根据已展开的行查询数据（用于保存后刷新时异步加载子级的数据）
    loadDataByExpandedRows(dataList) {
      if (this.expandedRowKeys.length > 0) {
        return getAction(this.url.getChildListBatch, { parentIds: this.expandedRowKeys.join(',') }).then(res => {
          if (res.success && res.result.records.length > 0) {
            //已展开的数据批量子节点
            let records = res.result.records
            const listMap = new Map();
            for (let item of records) {
              let pid = item[this.pidField];
              if (this.expandedRowKeys.join(',').includes(pid)) {
                let mapList = listMap.get(pid);
                if (mapList == null) {
                  mapList = [];
                }
                mapList.push(item);
                listMap.set(pid, mapList);
              }
            }
            let childrenMap = listMap;
            let fn = (list) => {
              if (list) {
                list.forEach(data => {
                  if (this.expandedRowKeys.includes(data.id)) {
                    data.children = this.getDataByResult(childrenMap.get(data.id))
                    fn(data.children)
                  }
                })
              }
            }
            fn(dataList)
          }
        })
      } else {
        return Promise.resolve()
      }
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>